module.exports = __webpack_public_path__ + "static/qr-dea4866ffa8531df52bb79e4df6e8c39.jpg";